module.exports = "/_next/static/images/ca0be1553650a15b4ace431e06e503b9-card.svg.webp";